export const BASE_URL = "https://backend.afro-group.com/api";
export const IMAGE_BASE_URL = "https://backend.afro-group.com/public";
export const DASHBOARD_URL = "https://backend.afro-group.com/";
